<template>
    <section class="app-main">
        <transition name="fade-transform" mode="out-in">
            <keep-alive include="首页">
                <router-view :key="key" />
            </keep-alive>
        </transition>
    </section>
</template>
  
<script>
export default {
    name: 'AppMain',
    computed: {
        cachedViews() {
            return '首页,我要送评'
        },
        key() {
            return this.$route.path
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/layout/components/AppMain.vue